export default __webpack_public_path__ + "static/media/gallery_18.9d5317e4.jpg";